import { Button } from "@/components/ui/button";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.png";
import logoWebP from "@/assets/logo.webp";

const Header = () => {
  return (
    <header className="bg-background border-b border-border py-3 sm:py-4 md:py-5 lg:py-6">
      <div className="container-comfortable">
        {/* Mobile/Tablet Layout */}
        <div className="flex flex-col lg:hidden gap-4 sm:gap-6">
          {/* Title and subtitle */}
          <div className="text-center sm:text-left">
            <Link to="/" className="block">
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-primary leading-tight hover:text-primary/80 transition-colors cursor-pointer">
                Digitaler Verrentungsberater
              </h1>
            </Link>
            <p className="text-xs sm:text-sm md:text-base text-muted-foreground mt-1">
              Ihr Weg zu mehr finanzieller Sicherheit im Alter
            </p>
          </div>

          {/* Logo */}
          <div className="flex justify-center">
            <picture>
              <source 
                srcSet={logoWebP} 
                type="image/webp"
                sizes="(max-width: 640px) 48px, (max-width: 768px) 64px, 80px"
              />
              <img 
                src={logo} 
                alt="Rente Plus Immobilie Logo" 
                className="h-12 sm:h-16 md:h-20 w-auto object-contain"
                width="80"
                height="80"
                decoding="async"
                sizes="(max-width: 640px) 48px, (max-width: 768px) 64px, 80px"
              />
            </picture>
          </div>

          {/* Contact button */}
          <div className="flex justify-center">
            <Button 
              variant="accent" 
              size="sm"
              className="text-sm sm:text-base px-4 sm:px-6 whitespace-nowrap"
              onClick={() => window.open("mailto:info@renteplusimmobilie.de", "_self")}
            >
              <Mail className="h-4 w-4 mr-2" />
              Kostenlose Beratung
            </Button>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:flex lg:items-center lg:justify-between">
          {/* Left: Logo and Phone stacked */}
          <div className="flex flex-col gap-3 items-start lg:flex-1">
            <picture>
              <source 
                srcSet={logoWebP} 
                type="image/webp"
                sizes="(max-width: 1280px) 64px, 80px"
              />
              <img 
                src={logo} 
                alt="Rente Plus Immobilie Logo" 
                className="h-16 xl:h-20 w-auto object-contain"
                width="80"
                height="80"
                decoding="async"
                sizes="(max-width: 1280px) 64px, 80px"
              />
            </picture>
            <button 
              className="flex items-center gap-2 text-primary hover:text-primary-hover transition-colors cursor-pointer whitespace-nowrap"
              onClick={() => window.open('tel:089628246446', '_self')}
            >
              <Phone className="h-4 w-4" />
              <span className="text-sm xl:text-base font-medium">089 62 82 46 46</span>
            </button>
          </div>

          {/* Center: Title */}
          <div className="text-center">
            <Link to="/" className="block">
              <h1 className="text-2xl xl:text-3xl font-bold text-primary leading-tight hover:text-primary/80 transition-colors cursor-pointer">
                Digitaler Verrentungsberater
              </h1>
            </Link>
            <p className="text-sm xl:text-base text-muted-foreground mt-1">
              Ihr Weg zu mehr finanzieller Sicherheit im Alter
            </p>
          </div>

          {/* Right: Contact button */}
          <div className="flex justify-end lg:flex-1">
            <Button 
              variant="accent" 
              size="sm"
              className="text-sm xl:text-base px-4 xl:px-6 whitespace-nowrap"
              onClick={() => window.open("mailto:info@renteplusimmobilie.de", "_self")}
            >
              <Mail className="h-4 w-4 mr-2" />
              Kostenlose Beratung
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;